export enum PrintParameterTypes {
  TICKET__ID = 'TICKET__ID',
  TICKET__DYNAMIC_PROPERTY = 'TICKET__DYNAMIC_PROPERTY',
  TICKET__CODE = 'TICKET__CODE',
  TICKET__TYPE = 'TICKET__TYPE',

  BOOKING__ID = 'BOOKING__ID',
  BOOKING__DYNAMIC_PROPERTY = 'BOOKING__DYNAMIC_PROPERTY',
  BOOKING__TYPE = 'BOOKING__TYPE',
  BOOKING__DISABLED = 'BOOKING__DISABLED',
  BOOKING__ACTIVE_FROM = 'BOOKING__ACTIVE_FROM',
  BOOKING__ACTIVE_TO = 'BOOKING__ACTIVE_TO',

  CUSTOMER__ID = 'CUSTOMER__ID',
  CUSTOMER__FIRSTNAME = 'CUSTOMER__FIRSTNAME',
  CUSTOMER__LASTNAME = 'CUSTOMER__LASTNAME',
  CUSTOMER__COMPANY = 'CUSTOMER__COMPANY',
  CUSTOMER__BIRTHDATE = 'CUSTOMER__BIRTHDATE',
  CUSTOMER__DOCUMENT_TYPE = 'CUSTOMER__DOCUMENT_TYPE',
  CUSTOMER__PESEL = 'CUSTOMER__PESEL',
  CUSTOMER__DOCUMENT_NUMBER = 'CUSTOMER__DOCUMENT_NUMBER',
  CUSTOMER__NATIONALITY = 'CUSTOMER__NATIONALITY',

  VARIANT__ID = 'VARIANT__ID',
  VARIANT__NAME = 'VARIANT__NAME',

  EVENT__ID = 'EVENT__ID',
  EVENT__DYNAMIC_PROPERTY = 'EVENT__DYNAMIC_PROPERTY',
  EVENT__NAME = 'EVENT__NAME',
  EVENT__STATUS = 'EVENT__STATUS',
  EVENT__DATE_START = 'EVENT__DATE_START',
  EVENT__DATE_END = 'EVENT__DATE_END',
  EVENT__EXTERNAL_ID = 'EVENT__EXTERNAL_ID',
  EVENT__INFIX = 'EVENT__INFIX',

  SEAT__ID = 'SEAT__ID',
  SEAT__ROW_ALIAS = 'SEAT__ROW_ALIAS',
  SEAT__NUMBER_ALIAS = 'SEAT__NUMBER_ALIAS',

  BLOCK__ID = 'BLOCK__ID',
  BLOCK__NAME = 'BLOCK__NAME',
  BLOCK__TYPE = 'BLOCK__TYPE',
  BLOCK__CODE = 'BLOCK__CODE',

  TRIBUNE__ID = 'TRIBUNE__ID',
  TRIBUNE__NAME = 'TRIBUNE__NAME',
  TRIBUNE__CODE = 'TRIBUNE__CODE',
  TRIBUNE__TYPE = 'TRIBUNE__TYPE',

  OBJECT__ID = 'OBJECT__ID',
  OBJECT__NAME = 'OBJECT__NAME',
}
